import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es para BLW o para papillas?',
  a: 'Es una guía flexible que explica BLW (Baby-Led Weaning o alimentación complementaria guiada por el bebé), papillas y alimentación combinada, para que elijas lo que mejor se adapta a tu bebé y a tu familia.'
}, {
  q: '¿Es útil si todavía no he empezado los sólidos?',
  a: 'Sí. De hecho, es ideal leerla antes de comenzar para entender señales, seguridad y primeros pasos.'
}, {
  q: '¿Incluye recetas?',
  a: 'Sí. Incluye recetas prácticas, nutritivas y adaptables a distintas etapas.'
}, {
  q: '¿Los bonos vienen incluidos?',
  a: 'Sí. Recibes el Plan Semanal de Introducción, La Despensa Consciente y Primeros Bocados: 30 Recetas Esenciales sin costo adicional.'
}, {
  q: '¿Es un producto físico?',
  a: 'No. Es un ebook digital descargable.'
}, {
  q: '¿Sirve si me da miedo el atragantamiento?',
  a: 'Sí. Uno de los enfoques centrales de la guía es ayudarte a entender mejor la seguridad alimentaria y sentirte más preparado/a.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-cream" data-id="element-97">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-98">
        <div className="text-center mb-16" data-id="element-99">
          <motion.h2 className="text-4xl font-serif text-charcoal" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-100">
            Preguntas frecuentes
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-101">
          {faqs.map((faq, i) => <motion.div key={i} className="bg-white border border-sand rounded-xl overflow-hidden" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-102">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-103">
                <span className="font-medium text-charcoal pr-8" data-id="element-104">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-warmGray transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-105" />
              </button>
              <AnimatePresence data-id="element-106">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-107">
                    <div className="px-6 pb-5 text-warmGray leading-relaxed border-t border-sand/50 pt-4" data-id="element-108">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}